import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 17,
	height: 20,
	viewBox: "0 0 17 20",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1 18.9996C1 16.6271 2.93259 13.6738 8.49999 13.6738C14.0674 13.6738 16 16.6059 16 18.9795",
			strokeWidth: 1.5,
			strokeLinecap: "square",
			strokeLinejoin: "round",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.7109 6C13.7109 8.76096 11.4727 11 8.71035 11C5.94911 11 3.71094 8.76096 3.71094 6C3.71094 3.23907 5.94911 1 8.71035 1C11.4727 1 13.7109 3.23907 13.7109 6Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			fill: "none"
		})
	]
});
const ForwardRef = forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
